import script from "./ExamResultsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamResultsView.vue?vue&type=script&setup=true&lang=ts"

import "./ExamResultsView.vue?vue&type=style&index=0&id=78ac5d66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ac5d66"]])

export default __exports__